// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uj13","title":"styles_title__3Ka1-"};